import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicMixedUse from "../Components/ProjPicMixedUse";

const ProjectPageMixedUse = () => {
    return (
        <>
            <Navbar />
            <ProjPicMixedUse />
            <Footer />
        </>
    );
};

export default ProjectPageMixedUse;
